import ActionType from './action-type'
import * as Actions from './actions'
import {Location} from './state'
import {ThunkAction} from 'redux-thunk'

import {REST} from '../../../index'
import {Api} from '../../../api/Api'
import AppState from '../../types/app-state'

const LOCATIONS_URL = '/api/v1/locations'

const setLocations = (locations: Location[]): Actions.SetLocationsAction => ({
    type: ActionType.SET_LOCATIONS,
    payload: locations,
})

const requestLocations = (): Actions.RequestLocationsAction => ({
    type: ActionType.REQUEST_LOCATIONS,
})

export const fetchLocations = (): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(requestLocations())

        REST.get(LOCATIONS_URL).then((response) => {
            dispatch(setLocations(response.data))
        })
    }
}
